/*
  Clean Cream — play a product card's video while the pointer is over the card.

  The markup ships with preload="none", so the file is not fetched until the
  first hover. On leaving, the clip pauses and rewinds so the next hover starts
  from the top rather than mid-shot.

  Bound per card via event delegation, which keeps it working for cards that
  arrive later (quick-add re-renders, section reloads in the theme editor).
*/
(function () {
  'use strict';

  if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  function videoIn(target) {
    if (!target || !target.closest) return null;
    var card = target.closest('.card-wrapper, .cc-bs__card');
    return card ? card.querySelector('.cc-card-video') : null;
  }

  document.addEventListener(
    'pointerover',
    function (event) {
      var video = videoIn(event.target);
      if (!video || video.dataset.ccHovering === 'true') return;
      video.dataset.ccHovering = 'true';
      // Belt and braces: some browsers only grant autoplay to a video whose
      // muted property (not just the attribute) is set before play().
      video.muted = true;
      // play() rejects if the element is detached or the file 404s; ignore it
      // rather than letting an unhandled rejection surface in the console.
      var played = video.play();
      if (played && typeof played.catch === 'function') played.catch(function () {});
    },
    { passive: true }
  );

  document.addEventListener(
    'pointerout',
    function (event) {
      var video = videoIn(event.target);
      if (!video) return;
      // pointerout also fires moving between children of the same card.
      if (event.relatedTarget && videoIn(event.relatedTarget) === video) return;
      delete video.dataset.ccHovering;
      video.pause();
      video.currentTime = 0;
    },
    { passive: true }
  );
})();
